<template>
    <a-modal v-model="visible" title="发放卡券" :width="500" @ok="doSubmit" @cancel="close" centered destroyOnClose
        :confirmLoading="loading">
        <a-form-model ref="formRef" :model="formData">
            <a-form-model-item label="发放活动" prop="activeId" :rules="[{ required: true, message: '请选择活动' }]">
                <a-select v-model="formData.activeId" placeholder="请选择活动" @search="findActive" @change="handleChange"
                    showSearch :filter-option="false" allowClear>
                    <a-select-option v-for="item in activeList" :key="item.activeId">
                        <a-space>
                            <span>{{ item.title }}</span>
                            <span v-if="item.discount > 0">{{ item.discount / 10 }}折</span>
                            <span v-if="item.money > 0">{{ item.money }} 元 </span>
                            <span>{{ item.couponType }}</span>
                            <span v-if="item.fullMoney > 0">(消费满{{ item.fullMoney }}元可用)</span>
                        </a-space>
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-row :gutter="12">
                <a-col :span="12">
                    <a-form-model-item label="发放用户" prop="phone" :rules="[{ required: true, message: '请选择发放用户' }]">
                        <a-input v-model="formData.phone" placeholder="请输入发放用户手机号" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="发放数量" prop="num" :rules="{ required: true, message: '请填写发放数量' }">
                        <a-input-number v-model="formData.num" :min="1" :max="100" placeholder="请输入发放数量"
                            style="width:100%" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-form-model-item label="备注信息" prop="remark" :rules="[{ required: true, message: '请输入备注信息' }]">
                <a-textarea v-model="formData.remark" placeholder="请输入备注信息" />
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>

<script>
import utils from '@/common/utils';

export default {
    data() {
        return {
            visible: false,
            loading: false,
            formData: {
                activeId: '',
                phone: '',
                num: 1,
                remark: ''
            },
            activeList: [],
            fetching: false
        }
    },
    methods: {
        show() {
            this.getActiveList();
            this.visible = true;
        },
        getActiveList(keyword) {
            this.http.get('/platform/coupon/active/list', { keyword: keyword ? keyword : '' }).then(res => {
                // console.log(res.data.records);
                this.activeList = res.data.records;
            })
        },
        close() {
            this.visible = false;
        },
        findActive(value) {
            this.activeList = [];
            this.fetching = true;
            this.getActiveList(value);
        },
        handleChange(value) {
            if (value == undefined) {
                this.getActiveList();
            }
        },
        doSubmit() {
            this.$refs.formRef.validate(valid => {
                if (!valid) {
                    return;
                }
                this.loading = true;
                this.http
                    .post('/platform/coupon/data/create', this.formData)
                    .then(ret => {
                        utils.success('操作成功！').then(() => {
                            this.$emit('success');
                            this.$refs.formRef.resetFields();
                            this.visible = false;
                        });
                    }).finally(() => {
                        this.loading = false;
                    });
            });

        }

    }
}
</script>

<style></style>